module.exports = __webpack_public_path__ + "media/images/jito-ebc97fdf.svg";